import React from 'react';
import './Coffee.css';
import latteImg from '../images/coffee/latte.png';
import coldBrewImg from '../images/coffee/coldbrew.png';
import espressoImg from '../images/coffee/espresso.png';

const Coffee = () => {
    return (
        <section className="coffee-section fade-in">
            <div className="coffee-container">
                <div className="coffee-content">
                    <span className="coffee-icon">☕</span>
                    <h2>Brewing Something New</h2>
                    <p className="status-text">
                        This space is currently under development.
                        Check back for personal updates, coffee recommendations, or just random thoughts.
                    </p>

                    <div className="polaroid-gallery">
                        <div className="polaroid-card">
                            <div className="polaroid-frame">
                                <img src={latteImg} alt="Latte Art" />
                            </div>
                        </div>
                        <div className="polaroid-card">
                            <div className="polaroid-frame">
                                <img src={coldBrewImg} alt="Cold Brew" />
                            </div>
                        </div>
                        <div className="polaroid-card">
                            <div className="polaroid-frame">
                                <img src={espressoImg} alt="Espresso" />
                            </div>
                        </div>
                    </div>

                    <div className="loader">
                        <span className="cursor">_</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Coffee;
